import { PracticeProfile, SpecialistProfile } from 'types'

export const getKeywords = (specialist?: SpecialistProfile, practice?: PracticeProfile) => {
    if (!specialist?.keywords.length && !practice?.keywords.length) {
      return []
  }
  return specialist?.keywords || practice?.keywords || []
}